import { handleize, variantTypes, findSelectedOption } from "@react/utilities";
import { SelectedVariantAvailability } from "@root/tablescape/constants";
import { type CartProductVariant } from "@tablescape/state";

export const findVariants = ({
  displayUnavailableVariants,
  selectedVariant,
  type,
  variants,
}: {
  displayUnavailableVariants: boolean;
  selectedVariant: CartProductVariant;
  type: (typeof variantTypes)[number];
  variants: CartProductVariant[];
}) => {
  const foundVariants = variants
    .filter((v) => findSelectedOption({ type, variant: v }))
    .filter((v) => {
      return variantTypes.every((t) => {
        if (t === type) {
          return true;
        }

        return findSelectedOption({
          type: t,
          variant: v,
        })
          ? findSelectedOption({
              type: t,
              variant: v,
              value: findSelectedOption({
                type: t,
                variant: selectedVariant,
              })?.value,
            })
          : true;
      });
    })
    .reduce<CartProductVariant[]>((variants, currentVariant) => {
      const variantOption = findSelectedOption({
        type,
        variant: currentVariant,
      });

      if (
        !currentVariant.hidden &&
        !variants.find((v) =>
          v.selectedOptions.find((currentOption) => {
            return (
              currentOption.name === variantOption?.name &&
              currentOption.value === variantOption?.value
            );
          })
        )
      ) {
        variants.push(currentVariant);
      }

      return variants;
    }, [])
    .sort((a, b) =>
      a.availableForSale && !b.availableForSale
        ? -1
        : a.availableForSale === b.availableForSale
        ? 0
        : 1
    );

  if (!displayUnavailableVariants) {
    return foundVariants.filter(
      (v) =>
        v.availableForSale &&
        (v.shippingNote
          ? handleize(v.shippingNote) !== SelectedVariantAvailability.SOLD_OUT
          : true)
    );
  }

  return foundVariants;
};
